<script setup lang="ts">
import {
  TwitterIcon,
  LinkedinIcon,
  FacebookIcon,
  InstagramIcon,
  LineSocialIcon,
  YoutubeIcon
} from '@hantecmarket/hantec-ui-widget'

defineProps<{
  twitter_link?: string
  linkedin_link?: string
  facebook_link?: string
  instagram_link?: string
  line_link?: string
  youtube_link?: string
}>()
</script>

<template>
  <div class="flex sm:justify-center lg:px-0">
    <a v-if="twitter_link" :href="twitter_link" class="text-white hover:text-gray-900">
      <TwitterIcon></TwitterIcon>
      <span class="sr-only">Twitter page</span>
    </a>
    <a
      v-if="linkedin_link"
      :href="linkedin_link"
      class="text-white hover:text-gray-900 ms-[26px] lg:ms-[37px]"
    >
      <LinkedinIcon></LinkedinIcon>
      <span class="sr-only">Linkedin page</span>
    </a>
    <a
      v-if="facebook_link"
      :href="facebook_link"
      class="text-white hover:text-gray-900 ms-[26px] lg:ms-[37px]"
    >
      <FacebookIcon></FacebookIcon>
      <span class="sr-only">Facebook page</span>
    </a>
    <a
      v-if="instagram_link"
      :href="instagram_link"
      class="text-white hover:text-gray-900 ms-[26px] lg:ms-[37px]"
    >
      <InstagramIcon></InstagramIcon>
      <span class="sr-only">Instagram page</span>
    </a>
    <a
      v-if="line_link"
      :href="line_link"
      class="text-white hover:text-gray-900 ms-[26px] lg:ms-[37px]"
    >
      <LineSocialIcon></LineSocialIcon>
      <span class="sr-only">Line page</span>
    </a>
    <a
      v-if="youtube_link"
      :href="youtube_link"
      class="text-white hover:text-gray-900 ms-[26px] lg:ms-[37px]"
    >
      <YoutubeIcon></YoutubeIcon>
      <span class="sr-only">Youtube channel</span>
    </a>
  </div>
</template>
